import MainThemeAudio from 'assets/sound/song.mp3';
import Transmission01Audio from 'assets/sound/transmission01.mp3';
import soundsMiddleware from 'redux-sounds';

// Our soundsData is an object. The keys are the names of our sounds.
const soundsData = {
  mainTheme: {
    src: MainThemeAudio,
    volume: 1,
    loop: true,
  },
  transmission01: {
    src: Transmission01Audio,
    volume: 1,
  },
};

// Pre-load our middleware with our sounds data.
const loadedSoundsMiddleware = soundsMiddleware(soundsData);

export default loadedSoundsMiddleware;
